import {Injectable} from "@angular/core";
import {WebSocketService} from "./websocket.service";
import {NbAuthService} from "@nebular/auth";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class TradingWsService extends WebSocketService {

  constructor(authService: NbAuthService) {
    super(authService, environment.mexExchange.websockets.url);
  }

}
